import { render, staticRenderFns } from "./childrenAllocate.vue?vue&type=template&id=285af38a&scoped=true&"
import script from "./childrenAllocate.vue?vue&type=script&lang=js&"
export * from "./childrenAllocate.vue?vue&type=script&lang=js&"
import style0 from "./childrenAllocate.vue?vue&type=style&index=0&id=285af38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285af38a",
  null
  
)

export default component.exports